import axios from 'axios'
import { baseURL } from './Consts'
import { setLoading } from '../store/reducers/commonReducer'
import store from '../store'
import { toast } from 'react-toastify'
const getToken = () => {
  return window.localStorage.getItem('token') ? localStorage.getItem('token') : null
}

const http = axios.create({
  baseURL,
  timeout: 20000,
  headers: {
    Authorization: `Bearer ${getToken()}`
  }
})

http.interceptors.request.use(function (config) {
  config.headers.Authorization = `Bearer ${getToken()}`
  return config
})

http.interceptors.response.use(function (response) {
  return response
}, function (err) {
  store.dispatch(setLoading(false))
  if (err.code === 'ERR_NETWORK') {
    toast.error('Server not responding')
  } else if (err.response.status && (err.response.status === 401 || err.response.status === 403 || err.response.status === 406)) {
    window.localStorage.clear()
    window.location.href = '/'
  } else {
    window.location.href = '/'
  }
  return Promise.reject(err)
})

export default http